import { API, graphqlOperation } from 'aws-amplify';
import gql from 'graphql-tag';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Observable } from 'zen-observable-ts';

import { setPaymentState, updateSubscription } from '../../actions';
import { OnUpdateUserPlanTimeStampSubscription } from '../../graphql/api';
import { store } from '../../index';

import { IState, Subscription } from '../../graphql/types';
import useUser from '../useUser';
import { PaymentState } from '../../types';
import usePlan from '../usePlan';

const onPlanUpdate = gql`
  subscription onPlanUpdate($userID: String!, $tenantID: String!) {
    onUpdateUserPlanTimeStamp(userID: $userID, tenantID: $tenantID) {
      createdAt
      id
      name
      subscriptionIDs
      tenantID
      updatedAt
      userID
      versionID
      accountStatus
      freeTrialEndDate
      totalGiidesCreated
      upgradePlans
      downgradePlans
      planChangeError
      paddlePlanID
      giidesCreatedListFreePlan {
        createdAt
        giideID
        updatedAt
      }
      features {
        chapters {
          allowChaptersWithExistingGiides
          allowChaptersWithFutureGiides
          createdAt
          hasLimit
          isActive
          maxNumberOfChapters
          name
          updatedAt
        }
        embedCode {
          allowEmbedCode
          createdAt
          isActive
          name
          updatedAt
        }
        giideDuplicate {
          allowGiideDuplicate
          createdAt
          isActive
          name
          updatedAt
        }
        giidePasswordProtection {
          allowGiidePasswordProtection
          createdAt
          isActive
          name
          updatedAt
        }
        giideMaxFileSizeAudio {
          updatedAt
          name
          isActive
          giideMaxFileSizeMBAudio
          createdAt
        }
        giideMaxLengthAudio {
          createdAt
          giideLengthInSeconds
          isActive
          name
          updatedAt
        }
        giideMaxNumberOfGiides {
          updatedAt
          name
          limitAmount
          isActive
          hasLimit
          createdAt
        }
        pollQuizFeature {
          createdAt
          isActive
          name
          updatedAt
        }
        recording {
          updatedAt
          name
          hasBrowserRecording
          createdAt
        }
      }
    }
  }
`;

const usePlanSubscription = () => {
  const dispatch = useDispatch();
  const { user } = useUser();

  const sub = useSelector<IState, Subscription | undefined>(
    state => state.subscriptions.updatePlan
  );

  // const paymentState = useSelector<IState, PaymentState>(
  //   state => state.paymentState
  // );

  const { refetch } = usePlan();

  const subscribe = React.useCallback(() => {
    if (user?.tenantID) {
      if (sub) {
        sub.unsubscribe();
      }
      const newObs = API.graphql(
        graphqlOperation(onPlanUpdate, {
          userID: user?.userId,
          tenantID: user?.tenantID,
        })
      );
      if (newObs instanceof Observable) {
        const newSub = newObs.subscribe({
          next: (result: {
            value: { data: OnUpdateUserPlanTimeStampSubscription };
          }) => {
            // dispatch(
            //   updateUser({
            //     plan: {
            //       ...result.value.data.onUpdateUserPlanTimeStamp!,
            //       id: result.value.data.onUpdateUserPlanTimeStamp!.id!,
            //     },
            //   })
            // );
            // Need to get fresh user data here, because this graphql call
            // returns an empty array for upgradePlans
            refetch();

            const { paymentState } = store.getState();

            if (paymentState === PaymentState.processing) {
              dispatch(setPaymentState(PaymentState.successful));
            }
          },
          error: console.log,
        });

        dispatch(updateSubscription('updatePlan', newSub));
      }
    }
  }, [sub, user?.tenantID, user?.userId, dispatch, refetch]);

  const unsubscribe = () => {
    if (user?.tenantID) {
      if (sub) {
        sub.unsubscribe();
      }
    }
  };

  return { subscribe, unsubscribe, sub };
};

export default usePlanSubscription;
